import { useDomains } from '@/lib/queries';
import { DomainCard } from '@/components/DomainCard';

export default function DomainsPage() {
  const q = useDomains();
  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
          Index · Bounded contexts
        </p>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight">Domains</h1>
        <p className="text-muted-foreground max-w-2xl">
          Every long-running operational concern lives in one of these contexts. Each card opens a
          domain page with guides, checklists, logs, photos, and inventory scoped to that area.
        </p>
      </header>
      {q.isLoading ? <p className="text-sm text-muted-foreground">Loading…</p> : null}
      {q.isError ? <p className="text-sm text-destructive">{(q.error as Error).message}</p> : null}
      {q.data ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {q.data.map((d) => (
            <DomainCard key={d.id} domain={d} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
